import { GridItemType } from "components/Chakra/Card/CardMotion";
import CardVariant from "components/Chakra/Card/CardVariant";

export const thirdTabItems: Array<GridItemType> = [
  {
    content: (
      <CardVariant
        type="IMAGE_BACKGROUND_BLACK"
        title="Pes, který za vás vyčmuchá nový domov"
        subTitle="Hlídací pes"
        bgImage={{
          scr: "/img/scenes/NewHomepage/wd.webp",
          filter: "brightness(0.9)",
        }}
        to="/hlidaci-pes"
        trackingElab="Hlídací pes"
      />
    ),
    gridItemSetting: { name: "A", h: { base: "360px", md: "440px" } },
  },
  {
    content: (
      <CardVariant
        type="IMAGE_BACKGROUND_WHITE"
        title="Provedeme vás světem realit"
        subTitle="Realitní blog"
        to="/radce/najemnik"
        bgImage={{ scr: "/img/scenes/NewHomepage/notebook-bed.webp" }}
        trackingElab="Realitní blog_zájemce"
      />
    ),
    gridItemSetting: { name: "B", h: { base: "200px", md: "440px" } },
  },
  {
    content: (
      <CardVariant
        type="GREY_LIGHT"
        title="Prověření v 5 rejstřících"
        subTitle="Sebeprověření"
        to="/sebeprovereni"
        trackingElab="SCC"
      />
    ),
    gridItemSetting: { name: "C", h: { base: "200px", md: "500px" } },
  },
  {
    content: (
      <CardVariant
        title="Přehledný účet usnadňující hledání"
        subTitle="Profil na bydlení"
        type="GREY_DARK"
        image={{
          src: "/img/scenes/NewHomepage/macbook1.webp",
          style: {
            position: "relative",
            bottom: "-10px",
            left: "-40px",
            objectFit: "cover",
            marginTop: "auto",
            maxWidth: "80%",
          },
        }}
        htmlTagType="BUTTON"
        trackingElab="Profil"
      />
    ),
    gridItemSetting: { name: "D", h: { base: "360px", md: "100%" } },
  },
  {
    content: (
      <CardVariant
        type="ORANGE"
        title="Užitečná příručka na prohlídku"
        to="/pruvodce-najemnika"
        subTitle="Tahák na prohlídku"
        image={{
          src: "/img/scenes/NewHomepage/pruvodceNajemnika.webp",
          style: {
            position: "relative",
            bottom: "-40px",
            objectFit: "cover",
            marginTop: "auto",
            maxWidth: "80%",
          },
        }}
        trackingElab="Tahák na prohlídku"
      />
    ),
    gridItemSetting: { name: "E", h: { base: "360px", md: "100%" } },
  },
];
